"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrows_exchange = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var arrows_exchange = function arrows_exchange(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'arrows_exchange', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M4.25 8C4.25 8.41421 4.58579 8.75 5 8.75H16C16.3033 8.75 16.5768 8.56727 16.6929 8.28701C16.809 8.00676 16.7448 7.68417 16.5303 7.46967L12.5303 3.46967C12.2374 3.17678 11.7626 3.17678 11.4697 3.46967C11.1768 3.76256 11.1768 4.23744 11.4697 4.53033L14.1893 7.25H5C4.58579 7.25 4.25 7.58579 4.25 8Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M5.81066 12.75L15 12.75C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25L4 11.25C3.69665 11.25 3.42317 11.4327 3.30709 11.713C3.191 11.9932 3.25517 12.3158 3.46967 12.5303L7.46967 16.5303C7.76256 16.8232 8.23744 16.8232 8.53033 16.5303C8.82322 16.2374 8.82322 15.7626 8.53033 15.4697L5.81066 12.75Z',
    fill: '#4B5563'
  }));
};

exports.arrows_exchange = arrows_exchange;